/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/quotes */
import { ElementRef, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilsResource } from 'src/app/resources/UtilsResource.resource';
import { ActionsEventsService } from '../actions-events/actions-events.service';
import * as moment from "moment";
import { StoreServiceLibrary } from '../store/store.service';
import { GeneralUtilService } from '../general-util/generalUtil.service';
import { CryptoService } from '../crypto/crypto.service';

declare var androidProxy: any;
declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  useJwtToken = false;

  binRestrictioList: {
    bines: string[]
  };

  constructor(
    private storeLibrary: StoreServiceLibrary,
    private http: HttpClient,
    private _eventsService: ActionsEventsService,
    private generalUtil: GeneralUtilService,
    private cryptoService: CryptoService,
  ) { }

  stringToBoolean(value: string) {
    switch (value) {
      case "true":
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  getJwtUse() {
    let idAplication = this.storeLibrary.getIdAplication();
    if (!idAplication) {
      idAplication = environment.idApplication;
    }
    const useJwtAuth =
      environment.configChannel[idAplication].useJwtToken || false;
    return useJwtAuth;
  }

  getJwtUseFilter(jwtFilter) {
    let idAplication = this.storeLibrary.getIdAplication();
    if (!idAplication) {
      idAplication = environment.idApplication;
    }
    const useJwtAuth =
      environment.configChannel[idAplication].useJwtTokenServices[jwtFilter] || false;
    return useJwtAuth;
  }

  isValidBinForThisAppMilesBlue(numberParam: string, strBinRestrictionList) {
    if (strBinRestrictionList) {
      try {
        this.binRestrictioList = JSON.parse(strBinRestrictionList);
      } catch (error) {
        UtilsResource.NSMarkLogError('Error al parsear string to JSON', error);
      }
    }
    return new Observable((observer) => {
      if (numberParam && numberParam.length >= 6) {
        const bin: string = numberParam.substring(0, 6);
        if (this.binRestrictioList && this.binRestrictioList.bines && this.binRestrictioList.bines.length > 0) {
          let haveBinValid = false;
          for (const binItem of this.binRestrictioList.bines) {
            if (bin == binItem) {
              haveBinValid = true;
              break;
            }
          }
          if (haveBinValid) {
            observer.next(true);
            observer.complete();
          } else {
            observer.next(false);
            observer.complete();
          }
        } else {
          observer.next(true);
          observer.complete();
        }
      } else {
        UtilsResource.ShowLog('*** AddCreditCard - isValidBinForThisApp - numberParam', numberParam);
        observer.error(false);
        observer.complete();
      }
    });
  }

  getYearAndMonth(expireDate, separator) {
    if (!expireDate || !separator) {
      return null;
    }
    if (!expireDate.toString().includes(separator)) {
      return null;
    }
    const month = expireDate.split(separator)[0];
    let year = expireDate.split(separator)[1];

    //
    const currentYear = (new Date()).getFullYear().toString();
    const firstTwoDigitsOfyear = currentYear.substring(0, 2);
    year = firstTwoDigitsOfyear + year;

    return { month: month, year: year };
  }


  // getBinBankUserLogged() {
  //   let result = "";

  //   const userData: UserData = this.storeLibrary.getUserData();
  //   if (
  //     userData &&
  //     userData.accountResultDto &&
  //     userData.accountResultDto.bin
  //   ) {
  //     result = userData.accountResultDto.bin;
  //   }
  //   return result;
  // }

  callService(objectReques: any) {
    const headers: HttpHeaders =
      objectReques.header != null ? objectReques.header : new HttpHeaders();
    return this.http.post(objectReques.url, objectReques.request, { headers });
  }

  validateResultOperationError(resultOperationObj: any) {
    if (this.isResultOperationCodeExpireSession(resultOperationObj)) {
      this.sessionHasExpire();
    }
  }

  sessionHasExpire() {
    this._eventsService.toExpireSession();
  }

  isResultOperationCodeExpireSession(resultOperationObj: any) {
    let result = false;
    if (
      resultOperationObj
      && resultOperationObj.code
      && resultOperationObj.code == "220" //Usuario sin session
    ) {
      result = true;
    }
    return result;
  }

  sendMessageToParent(msg) {
    // Make sure you are sending a string, and to stringify JSON
    // window.parent.postMessage(msg, '*');
    UtilsResource.ShowLog("sendMessageToParent::", msg);
    if (typeof androidProxy !== 'undefined') {
      androidProxy.postMessage(JSON.stringify(msg));
    } else if (window.webkit !== undefined && window.webkit !== 'undefined' &&
      window.webkit.messageHandlers.native != undefined && window.webkit.messageHandlers.native !== 'undefined') {
      window.webkit.messageHandlers.native.postMessage(JSON.stringify(msg));
    } else {
      window.parent.postMessage(msg, '*');
    }
  }

  validateLocalDate(localDate, dateService) {
    let idAplication = this.storeLibrary.getIdAplication();
    let languajeTimeDefault = atob(environment.configChannel[idAplication].languajeTimeDefault || '');
    const day = new Date().toLocaleString(languajeTimeDefault, {
      timeZone: localDate
    });

    const dayTemp = new Date(day);
    let date = moment(dayTemp).format('DD/MM/YYYY').toString();

    if (date == dateService) {
      this.generalUtil.setLocalDate(dayTemp);
      return true;
    } else {
      return false;
    }
  }

  getParametersFromUrl(url) {
    url = url.split('?')[1];
    // Params obj
    var params = {};
    // To lowercase
    // url = url.toLowerCase();
    // To array
    url = url.split('&');

    // Iterate over URL parameters array
    var length = url.length;
    for (var i = 0; i < length; i++) {
      // Create prop
      var prop = url[i].slice(0, url[i].search('='));
      // Create Val
      var value = url[i].slice(url[i].search('=')).replace('=', '');
      // Params New Attr
      params[prop] = value;
    }
    return params;
  };

  getAppValidationsForm(): any {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let objAppValidationsForm = {
      validations: {
        names: {
          pattern: "^[a-zA-ZÀ-ÿ]+(?: [a-zA-ZÀ-ÿ]+)?$",
          minLength: "3",
          maxLength: "20",
        },
        lastNames: {
          pattern: "^[a-zA-ZÀ-ÿ]+(?: [a-zA-ZÀ-ÿ]+)?$",
          minLength: "4",
          maxLength: "20",
        },
        cardName: {
          pattern: "^[a-zA-ZÀ-ÿ]{3,}(?: [a-zA-ZÀ-ÿ]+)?$",
          minLength: "3",
          maxLength: "20",
        },
        jobTitle: {
          minLength: "3",
          maxLength: "20",
        },
        company: {
          minLength: "3",
          maxLength: "20",
        },
        companyType: {
          minLength: "3",
          maxLength: "20",
        },
        message: {
          maxLength: "20",
        },
        email: {
          pattern: re
        },
        cellPhone: { pattern: "^[0-9]+$", minLength: "7", maxLength: "15" },
      },
    };
    let str = this.storeLibrary.getJustOneUniversalPropertie(
      "_APP_VALIDATIONS_FORM_LANDING_XYZ"
    );
    if (str) {
      try {
        objAppValidationsForm = JSON.parse(str);
      } catch (error) {
        UtilsResource.ShowLog("ERROR AL PARSEAR _APP_VALIDATIONS_FORM", error);
      }
    }
    return objAppValidationsForm;
  }
}
